import React from "react";

//@mui component
import { TableRowProps } from "@mui/material/TableRow";
import XTableRow from "@mui/material/TableRow";

const TableRow: React.FC<TableRowProps> = (props) => {
  return <XTableRow {...props}>{props.children}</XTableRow>
};
    
export default TableRow;
